export default function RelevanceSection() {
  const items = [
    'Início de um novo ciclo autárquico',
    'Alteração de pelouros, equipas ou prioridades políticas',
    'Necessidade de rever a estrutura orgânica',
    'Existência de sobreposição de funções ou indefinição de responsabilidades',
    'Processos internos morosos ou pouco claros',
    'Dificuldade em transformar prioridades políticas em execução técnica',
    'Preparação de candidaturas, projetos estruturantes ou planos estratégicos',
    'Necessidade de melhorar coordenação, desempenho e prestação de contas',
  ];

  return (
    <section id="quando-e-util" className="py-20 lg:py-24" style={{ backgroundColor: '#FFFFFF' }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-14 items-start">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="h-px w-8" style={{ backgroundColor: '#D1D5DB' }} />
              <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.7rem', fontWeight: 600, letterSpacing: '0.12em', textTransform: 'uppercase', color: '#9CA3AF' }}>
                Quando é útil
              </span>
            </div>
            <h2
              style={{ fontFamily: 'DM Sans, sans-serif', fontWeight: 700, fontSize: 'clamp(1.5rem, 3vw, 1.875rem)', lineHeight: 1.25, color: '#1a1a1a', marginBottom: '1.25rem', letterSpacing: '-0.02em' }}
            >
              Quando é útil?
            </h2>
            <p style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.95rem', color: '#6B7280', lineHeight: 1.75 }}>
              O GP Otimiza é especialmente relevante em momentos em que o Município precisa de rever a sua organização interna, reforçar a capacidade de resposta dos serviços ou preparar melhor a execução das prioridades do mandato.
            </p>
          </div>

          <div className="space-y-2">
            {items?.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-3.5 p-4"
                style={{ borderRadius: '5px', backgroundColor: '#FAFAFA', border: '1px solid #EBEBEB' }}
              >
                <div
                  className="flex-shrink-0 flex items-center justify-center w-5 h-5 mt-0.5"
                  style={{ borderRadius: '50%', backgroundColor: 'rgba(0,150,136,0.1)' }}
                >
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#009688" strokeWidth="3" aria-hidden="true">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <span style={{ fontFamily: 'DM Sans, sans-serif', fontSize: '0.875rem', color: '#374151', lineHeight: 1.65 }}>
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}